import { Button, Typography } from '@mui/material';
import { Box } from '@mui/material';
import { CloudArrowUp } from '@phosphor-icons/react';

const UploadKnowledgeBase = ({
  setIsModalOpen,
}: {
  setIsModalOpen?: (value: boolean) => void;
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          gap: 2,
          border: '1px dashed #DCE0E7',
          borderRadius: '8px',
          padding: '24px',
          maxWidth: '600px',
          width: '90%',
        }}
      >
        <Typography variant="body1" color="text.secondary">
          No files uploaded yet. Get started by uploading your first file.
        </Typography>
        <CloudArrowUp size={30} />
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: 'center' }}
        >
          Only <strong>Text or PDF</strong> files are supported. <br />
          Please upload a valid file.
          <br />
          (Max file size: 5MB)
        </Typography>
        <Button
          variant="contained"
          startIcon={<CloudArrowUp size={20} />}
          onClick={() => setIsModalOpen?.(true)}
          sx={{ textTransform: 'none', mt: 2 }}
        >
          Upload File
        </Button>
      </Box>
    </Box>
  );
};

export default UploadKnowledgeBase;
